import 'es6-promise/auto';
import * as React from 'react';
import * as _ from 'lodash';
import { PerformanceViewModel, ReserveRequest, IProductionModels } from './classes';
import PerformanceAddOnsDisplaySelection from './performance-addons-display-selection';
import { performanceDispatch } from './performance-addons';
import { addPerformance, ActionTypes } from './actions';

interface PerformanceAddOnsProductionDisplayProps {
    production: PerformanceViewModel;
    groupedProductions: Array<PerformanceViewModel>;
}


interface PerformanceAddOnsProductionDisplayState {
    groupedProductions: Array<PerformanceViewModel>;
}

class PerformanceAddOnsProductionDisplay extends React.Component<PerformanceAddOnsProductionDisplayProps, PerformanceAddOnsProductionDisplayState>{
    constructor(props) {
        super(props);
        this.state = {
            groupedProductions: this.props.groupedProductions
        }
    }

    componentWillReceiveProps(props) {
        const { groupedProductions } = this.props;
        if (props.groupedProductions !== groupedProductions) {
            this.setState({
                groupedProductions: this.props.groupedProductions
            })
        }
    }

    getProgramNotesLink(url) {
        if (url !== null && url.length > 0) {
            return (<a href={url}>View Full Program</a>)
        }
    }

    addMorePerformance(productionId: number, guid: string): void {
        var productionModel = undefined;
        var bootStrapdata = (JSON.parse(JSON.stringify((window as any).bootStrappedData)) as IProductionModels);
        var productionList = bootStrapdata.performanceModels;
        for (let i = 0; i < productionList.length; i++) {
            if (productionList[i].productionId === Number(productionId)) {
                productionModel = JSON.parse(JSON.stringify(productionList[i]));
                break;
            }
        }
        performanceDispatch()(addPerformance(productionModel));
    }

    morePerformance(e): void {
        let identifier = e.target.value;
        let indexOfSeperator = identifier.indexOf(',');
        let productionID = identifier.substr(0, indexOfSeperator);
        let guid = identifier.substr(indexOfSeperator + 1);
        this.addMorePerformance(productionID, guid);
        //window.dispatchEvent(new Event('resize'));

        var resizeEvent = window.document.createEvent('UIEvents');
        resizeEvent.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(resizeEvent);
    }

    getIdentifier(production: PerformanceViewModel): string {
        return production.productionId + "," + production.guid;
    }

    render() {
        return (
            <>
                <dt className="adage-accordion-item" aria-level={3} id={"prod_"+this.props.production.productionId.toString() + "-heading"}>
                    <h3 className="adage-accordion-trigger" aria-controls={"prod_" + this.props.production.productionId.toString()} aria-expanded="false" dangerouslySetInnerHTML={{ __html: this.props.production.productionName }}></h3>
                </dt>
                <dd className="adage-accordion-panel" aria-hidden="true" role="region" id={"prod_" +this.props.production.productionId.toString()} aria-labelledby={"prod_" +this.props.production.productionId.toString() + "-heading"}>
                    <div className="adage-accordion-panel-content" data-accordion-content-id={"prod_" +this.props.production.productionId.toString()}>
                        <p dangerouslySetInnerHTML={{ __html: this.props.production.subHeading }}></p>
                        {this.getProgramNotesLink(this.props.production.programNotesUrl)}
                        {
                            this.props.groupedProductions.map((value, index) => {
                                return (
                                    <PerformanceAddOnsDisplaySelection production={value} key={index} />
                                );
                            })
                        }
                        <button type="button" onClick={this.morePerformance.bind(this)} value={this.getIdentifier(this.props.production)} > Add More</button>
                    </div>
                </dd>
            </>
        );
    }
}

export default PerformanceAddOnsProductionDisplay;